








































import { Vue, Component, Prop } from 'vue-property-decorator';
import { getBooking, getBookingPrescriber } from '@/api/api';
import Booking from '@/models/Booking';
import BookingStatus from '@/components/common/BookingStatus.vue';
import BookingInfos from '@/components/common/BookingInfos.vue';
import BookingFormAdmin from '@/components/BookingFormAdmin.vue';
import BookingFormPrescriber from '@/components/prescriber/BookingFormPrescriber.vue';
import AuthModule from '../../store/AuthModule';
import BookingDocuments from '@/components/common/BookingDocuments.vue';
import BookingPrivateDocuments from '@/components/BookingPrivateDocuments.vue';
import formatCustomer from '@/utils/formatCustomer';

@Component({
    components: {
        BookingStatus,
        BookingInfos,
        BookingFormAdmin,
        BookingFormPrescriber,
        BookingDocuments,
        BookingPrivateDocuments
    },
    filters: {
        formatCustomer,
    },
})
export default class BookingComponent extends Vue {
    @Prop() id!: string | undefined;
    @Prop({ type: Boolean, default: false }) asAdmin!: boolean;
    booking: Booking | null = null;

    async created() {
        this.applyPersonalColor();

        if (!this.id) {
            return;
        }

        if (this.asAdmin) {
            const { data } = await getBooking(+this.id);
            this.booking = data;
        } else {
            const { data } = await getBookingPrescriber(+this.id);
            this.booking = data;
        }
    }

    applyPersonalColor(): void {
        const hexColor = AuthModule.personal_color || '#891A2B';
        const match = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexColor);
        if (match) {
            const r = parseInt(match[1], 16);
            const g = parseInt(match[2], 16);
            const b = parseInt(match[3], 16);
            document.documentElement.style.setProperty('--primary-color', hexColor);
            document.documentElement.style.setProperty('--vs-primary', `${r}, ${g}, ${b}`);
            document.documentElement.style.setProperty('--vs-personal_color', `${r}, ${g}, ${b}`);
        }
    }
}
